module.exports = __webpack_public_path__ + "static/media/guestmode.9c3a2371.png";